import { useEffect, useState } from "react";
import { includes, trim } from "lodash";

export interface useSortMakerResult {
  sortColumns: string[];
  order: { key: string; value: "asc" | "desc" }[];
  orderBy: string[];
  onSort: (key: string) => void;
}

export function useSortMaker(
  sortColumns: string[],
  ordering: string | undefined,
  set_ordering: (values: string) => void,
  multiple?: boolean
): useSortMakerResult {
  const [order, setOrder] = useState<{ key: string; value: "asc" | "desc" }[]>(
    ordering
      ? ordering.split(",")?.map((el) => ({
          key: trim(el, "-"),
          value: el?.[0] === "-" ? "desc" : "asc",
        }))
      : []
  );
  const [orderBy, setOrderBy] = useState<string[]>(
    ordering ? ordering.split(",")?.map((el) => trim(el, "-")) : []
  );

  useEffect(() => {
    if (!ordering) {
      setOrderBy([]);
      setOrder([]);
    }
  }, [ordering]);

  const onSort = (key: string) => {
    if (multiple) {
      if (includes(ordering?.split(","), `-${key}`)) {
        const newOrders = orderBy.filter((el) => el !== key);
        const newOrdering = ordering
          ?.split(",")
          .filter((el) => el !== `-${key}`);
        set_ordering(newOrdering?.join(",") || "");
        setOrderBy(newOrders);
        setOrder(order.filter((el) => el.key !== key));
        return;
      }
      if (!includes(ordering?.split(","), key)) {
        const newOrders = [...orderBy, key];
        const newOrdering = [...(ordering ? ordering.split(",") : []), key];
        set_ordering(newOrdering.join(","));
        setOrderBy(newOrders);
        setOrder([...order, { key, value: "asc" }]);
        return;
      }
      if (includes(ordering?.split(","), key)) {
        const newOrdering = ordering
          ?.split(",")
          .map((el) => (el === key ? `-${key}` : el));
        set_ordering(newOrdering?.join(",") || "");
        setOrderBy(orderBy);
        setOrder(
          order.map((el) => (el.key === key ? { key, value: "desc" } : el))
        );
      }
    } else {
      if (includes(ordering?.split(","), `-${key}`)) {
        set_ordering("");
        setOrderBy([]);
        setOrder([]);
        return;
      }
      if (!includes(ordering?.split(","), key)) {
        set_ordering(key);
        setOrderBy([key]);
        setOrder([{ key, value: "asc" }]);
        return;
      }
      if (includes(ordering?.split(","), key)) {
        set_ordering(`-${key}`);
        setOrderBy([key]);
        setOrder([{ key, value: "desc" }]);
      }
    }
  };

  return {
    sortColumns,
    order,
    orderBy,
    onSort,
  };
}
